import { Button } from 'components/Button';

interface SortButtonProps {
  onClick: () => void;
  text: string;
  className: string;
  textClassName: string;
}

export const SortButton = ({ onClick, text, className, textClassName }: SortButtonProps) => {
  return (
    <Button onClick={onClick} className={className} appearance="secondary">
      <p className={textClassName}>{text}</p>
    </Button>
  );
};
